"use server";

import type { Currency, CurrencyDetailed } from "../types/index";
import db from "../utils/prisma";

export async function getAllCurrencies(): Promise<Currency[]> {
  return await db.currency.findMany({
    orderBy: { name: "asc" },
    select: {
      code: true,
      name: true,
      symbol: true,
      decimalPlaces: true,
    },
  });
}

export async function getCurrencyByName(
  currencyName: string
): Promise<CurrencyDetailed | null> {
  if (!currencyName) return null;

  return await db.currency.findFirst({
    where: { name: currencyName },
    select: {
      code: true,
      name: true,
      symbol: true,
      decimalPlaces: true,
      countries: {
        select: {
          code: true,
          name: true,
        },
      },
      states: {
        select: {
          id: true,
          name: true,
        },
      },
    },
  });
}

export async function getCurrencyByCode(
  currencyCode: string
): Promise<CurrencyDetailed | null> {
  if (!currencyCode) return null;

  return await db.currency.findUnique({
    where: { code: currencyCode },
    select: {
      code: true,
      name: true,
      symbol: true,
      decimalPlaces: true,
      countries: {
        select: {
          code: true,
          name: true,
        },
      },
      states: {
        select: {
          id: true,
          name: true,
        },
      },
    },
  });
}

export async function getCurrencyOfCountry(
  countryCode: string
): Promise<Currency | null> {
  if (!countryCode) return null;

  const country = await db.country.findUnique({
    where: { code: countryCode },
    select: {
      currency: {
        select: {
          code: true,
          name: true,
          symbol: true,
          decimalPlaces: true,
        },
      },
    },
  });

  return country?.currency || null;
}

export async function getCurrencyOfState(
  stateId: number
): Promise<CurrencyDetailed | null> {
  if (!stateId) return null;

  const state = await db.state.findUnique({
    where: { id: stateId },
    select: {
      currency: {
        select: {
          code: true,
          name: true,
          symbol: true,
          decimalPlaces: true,
        },
      },
      country: {
        select: {
          currency: {
            select: {
              code: true,
              name: true,
              symbol: true,
              decimalPlaces: true,
            },
          },
        },
      },
    },
  });

  return state?.currency || state?.country?.currency || null;
}
